module.exports = __webpack_public_path__ + "static/media/showcase5.c1ed43f8.webp";